import React from 'react';
import { BookOpen, Sparkles } from 'lucide-react';
import { motion } from 'framer-motion';
export function Header() {
  return <motion.header initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5
  }} className="sticky top-0 z-50 w-full bg-[#F5F1E8]/98 backdrop-blur-md border-b border-[#C9A961]/20 shadow-sm" data-id="element-186">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between" data-id="element-187">
        {/* Left: Logo + Brand */}
        <div className="flex items-center gap-3" data-id="element-188">
          <div className="bg-[#C9A961] p-2 rounded-lg text-white shadow-md" data-id="element-189">
            <BookOpen size={24} data-id="element-190" />
          </div>
          <div className="flex items-center gap-2" data-id="element-191">
            <Sparkles size={16} className="text-[#C9A961]" data-id="element-192" />
            <span className="font-bold text-lg text-[#1a3a52] tracking-tight" data-id="element-193">
              Oferta Especial de Lanzamiento
            </span>
          </div>
        </div>

        {/* Right: CTA Button */}
        <a href="#offer" className="hidden sm:flex items-center gap-2 px-6 py-3 bg-[#1a3a52] text-white rounded-full text-sm font-bold hover:bg-[#0f2942] transition-all duration-300 shadow-lg hover:shadow-xl" data-id="element-194">
          <Sparkles size={16} data-id="element-195" />
          Edición Premium
        </a>
      </div>
    </motion.header>;
}